import React, {useEffect, useMemo, useRef, useState} from 'react';
import styles from "./IdoAdministration.module.scss";
import {Checkbox, FormControlLabel, MenuItem, TextField} from "@mui/material";
import {PROD_API_URL} from "../../constants/constants";
import {
  calculateBlockchain,
  hasValue,
  saveSingleCadetValue,
  useDebouncedEffect
} from "../../helpers/helperFunctions.js";
import moment from "moment/moment";
import {setFilters, setIdoData} from "../../Components/Header/idoData";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {PATH_IDO_ADMINISTRATION} from "../../App";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import {DataGrid} from "@mui/x-data-grid";
import toast from "react-hot-toast";
import {errorToast} from "../../helpers/toastCSS";
import TextInput from "../../Components/TextInput/TextInput";
import {isSaleOngoing} from "../../helpers/idoHelper";

const idoTypes = [
  {
    value: 'PUBLIC',
    label: 'Public Sale',
  },
  {
    value: 'PRIVATE',
    label: 'Private Sale',
  },
  {
    value: 'NODE',
    label: 'NODE SALE',
  },
  {
    value: 'NFT',
    label: 'NFT SALE',
  },
  {
    value: 'LAUNCH_VOTE',
    label: 'Project Launch Vote',
  },
  {
    value: '',
    label: 'None',
  }
];

const columns = [
  { field: 'name', headerName: 'Name', flex: 1 },
  { field: 'status', headerName: 'Status', flex: 0.5},
  { field: 'saleType', headerName: 'Sale Type' },
  { field: 'hasPool', headerName: 'Pool Created' },
  { field: 'pair', headerName: 'Pair', flex: 0.5 },
  { field: 'dollarAmount', headerName: 'Dollar Amount', flex: 0.5 },
  { field: 'symbol', headerName: 'Symbol' },
  { field: 'blockchain', headerName: 'Blockchain', flex: 0.5},
  { field: 'production', headerName: 'Production' },
  { field: 'registrationStart', headerName: 'Registration Start', flex: 1},
];

export const NEW_IDO_ID = 'newIDO'
function IdoAdministration() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminUser = useSelector(state => state.userData.adminUser)
  const allIDOs = useSelector(state => state.idoData.allIDOs)
  const filters = useSelector(state => state.idoData.filters)

  const [filterName, setFilterName] = useState(filters.name);
  const [showActiveIdos, setShowActiveIdos] = useState(filters.showActiveIdos);
  const [filterIdoType, setFilterIdoType] = useState(filters.saleType);

  useEffect( ()=>{
    const fetchSaleData = async () => {
      fetch(PROD_API_URL+"/sales/", {
        "method": "POST",
        "headers": {"content-type": "application/json", "accept": "*"},
      }).then(res=>res.json())
        .then((result)=>{
          dispatch(setIdoData(result.data.sales_json.sales))
        });
    }

    fetchSaleData();
  },[]);

  const filteredRows = useMemo(() => allIDOs.filter(row => {
    if (hasValue(filterName) && !row.name.toLocaleLowerCase().includes(filterName.toLocaleLowerCase())) {
      return false;
    }

    const isActive = isSaleOngoing(row);

    if (showActiveIdos === true && isActive === false) {
      return false
    }

    if (hasValue(filterIdoType) && filterIdoType !== row.saleType) {
      return false;
    }

    return true;
  }).map(ido => {
    const blockchain = calculateBlockchain(ido);

    return (
        {
          id: ido.id,
          name: ido.name,
          status: ido.status,
          saleType: ido.saleType,
          hasPool: hasValue(ido.poolname) ? 'Yes' : 'No',
          pair: ido.pair,
          dollarAmount: ido.dollarAmount,
          symbol: ido.symbol,
          blockchain: blockchain,
          production: ido.production ? 'Yes' : 'No',
          registrationStart: moment.unix(ido.registrationStartTime).format('YYYY-MM-DD , h:mm A')
        }
    )
  }), [filterName, allIDOs, showActiveIdos, filterIdoType]);
  console.log(filteredRows);
  useDebouncedEffect(() => {
    const filterObject =
        { name: filterName, showActiveIdos: showActiveIdos, saleType: filterIdoType };

    if (filters.name !== filterObject.name || filters.saleType !== filterObject.saleType|| filters.showActiveIdos !== filterObject.showActiveIdos) {
      dispatch(setFilters(filterObject))
    }
  }, 1000,[filterName, showActiveIdos, filterIdoType])

  const redirectToCreateOrEdit = (id) => {
    if (adminUser.canEditIdo !== true) {
      return toast('You do not have access to edit IDOs', errorToast);
    }

    navigate(`${PATH_IDO_ADMINISTRATION}/${id}`);
  }


  return (
    <main id="home" key="home" className={styles.mainIdoContainer}>
       <div className={styles.idoAdminContainer}>
         <div className={styles.idoFilterContainer}>
           <div className={styles.idoMediumFilterInput}>
             <TextInput label="Filter IDO Name" value={filterName} setValue={setFilterName}/>
           </div>
           <div className={styles.idoSmallFilterInput}>
             <FormControlLabel
                 control={<Checkbox checked={showActiveIdos}
                                    onChange={event => setShowActiveIdos(event.target.checked)}/>}
                 label="Show Active IDOs"
                 labelPlacement="top"
             />
           </div>
           <div className={styles.idoSmallFilterInput}>
             <TextField
                 id="outlined-select-currency"
                 select
                 label="Select IDO Sale Type"
                 defaultValue={filterIdoType}
                 helperText="Select IDO Sale Type">
               {idoTypes.map((option) => (
                   <MenuItem key={option.value} value={option.value} onClick={() => setFilterIdoType(option.value)}>
                     {option.label}
                   </MenuItem>
               ))}
             </TextField>
           </div>
         </div>
         <div className={styles.idoTableContainer}>
           {allIDOs.length === 0 && <LoadingSpinner local/>}
           {allIDOs.length > 0 &&
               <DataGrid
                   rows={filteredRows}
                   onCellDoubleClick={(params) => redirectToCreateOrEdit(params.row.id)}
                   columns={columns}
               />

           }
         </div>
         <div className={styles.idoTableFooter}>
           <Button text="CREATE NEW IDO" buttonType={BUTTON_TYPE_SECONDARY} onClick={() => redirectToCreateOrEdit(NEW_IDO_ID)} />
         </div>
       </div>
    </main>

  );
}

export default IdoAdministration;
